import styled from "styled-components/macro";

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 36px;
    
  .swiper-wrapper {
    padding-bottom: 20px;
    display: flex;

    &:has(.swiper-slide:only-child) {
      justify-content: center;
    }
    
    @media (min-width: 980px) {
      &:has(.swiper-slide:nth-child(-n+2):last-child) {
        justify-content: center;
      }
    }
  }

  .swiper-pagination {
    bottom: 0;
  }
  
  .swiper-slide {
    height: auto;
    
    @media (min-width: 980px) {
      width: calc((100% - 48px) / 3) !important;
    }
    
    @media (max-width: 979px) and (min-width: 451px) {
      width: calc((100% - 24px) / 2) !important;
    }
    
    @media (max-width: 450px) {
      width: 100% !important;
    }
  }

  .swiper-wrapper:has(.swiper-slide:only-child) .swiper-slide:last-child,
  .swiper-wrapper:has(.swiper-slide:nth-child(-n+2):last-child) .swiper-slide:last-child {
    margin-right: 0 !important;
  }

  .swiper-pagination-bullet {
    background-color: rgba(85, 116, 159, 1);
    width: 38px;
    height: 2px;
    border-radius: 0;
  }

  .swiper-pagination-bullet-active {
    background-color: #55749F;
    width: 38px;
    height: 2px;
    border-radius: 0;
  }
`;
